import { queryOptions } from '@tanstack/react-query'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

const basePath = '/api/transport-units'
const client = new Client(getConfig().API_ENDPOINT ?? '')

export type DangerousGoodUnNumberResponse = {
  _id: string
  unNumber: string
  description: string
  unClass: number
  division: string | null
  isSupported: boolean
}
// Type copied over since we don't have a dependency on the transport units client here
export type TransportUnitResponse = {
  code?: string
  displayName?: string
  label?: string | null
  aliases: {
    aliasType?: string
    values?: string[]
  }[]
}

const getListOfDangerousGoodNumbers = async () => {
  return await client.get<DangerousGoodUnNumberResponse[]>(`${basePath}/api/dangerous-goods/list`)
}

export const dangerousGoodNumbersQueryOptions = queryOptions({
  queryKey: ['dangerous-goods-numbers-query-key'],
  queryFn: () => getListOfDangerousGoodNumbers(),
})

const getTransportUnits = async () => {
  return await client.get<TransportUnitResponse[]>(`${basePath}/api/types/list`)
}

export const transportUnitsQueryOptions = queryOptions({
  queryKey: ['transport-units-query-key'],
  queryFn: () => getTransportUnits(),
  // Stale time is set to 12 hours so it only refreshes this data once or twice a day, it's not expected to update that often
  staleTime: 12 * 60 * 60 * 1000,
})
